import { Box, Stack, TextareaAutosize } from "@mui/material";
import QRcode from "assets/images/tca/2/QRcodeFU02RelapsePreventionPart2.png";
import { useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import ReactToPrint from "react-to-print";

import VideoBlock from "../VideoBlock";
import YmcaPageHeader from "../YmcaPageHeader";

const StageFollowup02 = ({ sendContractToBackend }) => {
  const formContext = useFormContext();
  const { control, watch } = formContext;
  const watchFieldsToPrint = watch(["smsFollowUp02.barriers", "smsFollowUp02.feelings"]);
  const printTemplateRef = useRef();

  return (
    <>
      <Box className="greenContainer">
        <Box className="containerPadding">
          <Stack>
            <Box className="header1" mb={"20px"}>
              Follow Up Appointment 2
            </Box>
            <Box className="header2 green" mb={"16px"}>
              RELAPSE PREVENTION PART 2
            </Box>
          </Stack>
          <VideoBlock
            thumbnail="https://img.youtube.com/vi/Obd8_FfPCIY/maxresdefault.jpg"
            youtubeLink={
              "https://www.youtube.com/watch?v=Obd8_FfPCIY&list=PLgBxj8BHl0M33FtRIckAJCR0JEjqz2ujJ&index=7"
            }
          >
            <>
              <Box className="text text-bold video-title" mt={0.75} mb={2}>
                Watch this second video about Relapse Prevention to get started!
              </Box>
              <Box className="text text-bold">
                Go back to your first worksheet on Relapse Prevention and remind yourself of the
                barriers you identified to working out, as well as the work-arounds or solutions you
                came up with.
              </Box>
            </>
          </VideoBlock>
          <Box className="text text-bold" mb={2.5}>
            Now let's talk about what to do when our best efforts let us down.
          </Box>
          <Box className="text text-bold" mb={2}>
            Close your eyes and think about the last several weeks of your exercise plan. Did you
            have any days where your barriers got in the way and your back-up plan didn't work? Or
            maybe things went according to your plan. Write down some examples:
          </Box>
          <Controller
            name="smsFollowUp02.barriers"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Stack spacing={1} mt={2} className="note-input-container">
                <TextareaAutosize
                  {...field}
                  aria-label="description textarea"
                  className="note-textarea"
                  placeholder="Please enter"
                />
              </Stack>
            )}
          />
          <Box className="text text-bold" mt={2} mb={1}>
            It's important that we think about the feelings associated with those events. Maybe you
            felt frustrated or disappointed in yourself? On the flipside, maybe you felt proud or
            happy.
          </Box>
          <Box className="text text-bold" mb={2}>
            Note the feelings you identified in the situations you listed above:
          </Box>
          <Controller
            name="smsFollowUp02.feelings"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Stack spacing={1} mt={2} className="note-input-container">
                <TextareaAutosize
                  {...field}
                  aria-label="description textarea"
                  className="note-textarea"
                  placeholder="Please enter"
                />
              </Stack>
            )}
          />
          <Box className="text text-bold" mt={2} mb={1}>
            Keep those feelings close so that when the scenario presents itself again, you can think
            back to how you felt when you were or weren't successful — these feelings may help the
            next time you're faced with a barrier.
          </Box>
          <Stack className="whiteBox" mb={"20px"}>
            <Box className="header2" mb={2.5}>
              Here are a few more ways that we can add flexibility to our plan to allow for success
              even on the craziest of days:
            </Box>
            <Box className="text">
              <ul>
                <li>Short but more frequent sessions</li>
                <li>Accumulating sessions over a month vs. a week</li>
                <li>Alternating formats of exercise or places to exercise.</li>
              </ul>
              <br />
              Remember, any bit of exercise counts and is always better than none! And, if you have
              a bad day/exercise session, you can start again tomorrow.
            </Box>
          </Stack>
        </Box>
        <hr className="containerDivider" />
        <Stack direction={"row"} justifyContent="space-around">
          <button type="button" className="action-button" onClick={() => sendContractToBackend()}>
            Email Document to the Member
          </button>
          <ReactToPrint
            trigger={() => (
              <button type="button" className="action-button">
                Print Document
              </button>
            )}
            content={() => printTemplateRef.current}
          />
        </Stack>
      </Box>
      <div className="out-of-sight">
        <Stack ref={printTemplateRef} className="elementToPrint">
          <YmcaPageHeader />
          <Stack direction={"row"} gap={2}>
            <img src={QRcode} width="114" height="114" />
            <Stack>
              <h1 style={{ color: "#00a98f" }}>RELAPSE PREVENTION PART 2</h1>
              <Box mb={2}>
                <p>Watch this second video about Relapse Prevention to get started!</p>
              </Box>
              <Box>
                <p>
                  Go back to your first worksheet on Relapse Prevention and remind yourself of the
                  barriers you identified to working out, as well as the work-arounds or solutions
                  you came up with.
                </p>
              </Box>
            </Stack>
          </Stack>
          <Stack>
            <Box my={2}>
              <p>Now let's talk about what to do when our best efforts let us down.</p>
            </Box>
            <Box mb={2}>
              <p>
                Close your eyes and think about the last several weeks of your exercise plan. Did
                you have any days where your barriers got in the way and your back-up plan didn't
                work? Or maybe things went according to your plan. Write down some examples:
              </p>
            </Box>
            <Box
              className="filledFormField p_wrap"
              style={{
                background: "#edf6ff",
                border: "dotted 1px #313a3d",
                padding: "10px",
                whiteSpace: "pre-line",
              }}
            >
              {watchFieldsToPrint[0]}
            </Box>
            <Box my={2}>
              <p>
                It's important that we think about the feelings associated with those events. Maybe
                you felt frustrated or disappointed in yourself? On the flipside, maybe you felt
                proud or happy.
              </p>
            </Box>
            <Box mb={2}>
              <p>Note the feelings you identified in the situations you listed above:</p>
            </Box>
            <Box
              className="filledFormField p_wrap"
              style={{
                background: "#edf6ff",
                border: "dotted 1px #313a3d",
                padding: "10px",
                whiteSpace: "pre-line",
              }}
            >
              {watchFieldsToPrint[1]}
            </Box>
            <Box my={2}>
              <p>
                Keep those feelings close so that when the scenario presents itself again, you can
                think back to how you felt when you were or weren't successful — these feelings may
                help the next time you're faced with a barrier.
              </p>
            </Box>
            <Box mb={2}>
              <p>
                Here are a few more ways that we can add flexibility to our plan to allow for
                success even on the craziest of days:
                <br />
                <br />
              </p>
              <div style={{ marginBottom: "8px", marginLeft: "16px" }}>
                <span>&#8226;</span> Short but more frequent sessions
              </div>
              <div style={{ marginBottom: "8px", marginLeft: "16px" }}>
                <span>&#8226;</span> Accumulating sessions over a month vs. a week
              </div>
              <div style={{ marginBottom: "16px", marginLeft: "16px" }}>
                <span>&#8226;</span> Alternating formats of exercise or places to exercise.
              </div>
              <p>
                Remember, any bit of exercise counts and is always better than none! And, if you
                have a bad day/exercise session, you can start again tomorrow.
              </p>
            </Box>
          </Stack>
        </Stack>
      </div>
    </>
  );
};

export default StageFollowup02;
